import axios from "axios";
import { utilUrl } from "./utilUrl";

export class AuthServices {

    async requestPost(body, indexUrl) {
        const { url, apiLambda } = utilUrl();
        let urlRq;
        let headers;
        const f = new FormData();
        if (apiLambda) {
            headers = {
                'Content-Type': 'multipart/form-data'
            }
            f.append('urlPath', `${url[indexUrl].urlDominioServidor}${url[indexUrl].pathLambda}`)
            f.append('body', JSON.stringify(body))
            urlRq = `${url[indexUrl].urlEntornoLambda}`;
        } else {
            headers = {
                'Accept': 'application/json',
                'Content-type': 'application/json',
                "Access-Control-Allow-Origin": '*'
            }
            urlRq = `${url[indexUrl].urlEntornoLocal}${url[indexUrl].pathLambda}`;

        }
        const rqBody = apiLambda ? f : body;
        return axios.post(urlRq, rqBody, headers)
    }

    requestPutFileUrlPresigned(fileImage, presignedUrl, fileType) {
        const headers = {
            'Content-Type': fileType,
        }
        return new Promise((resolve, reject) => {
            axios.put(presignedUrl, fileImage, {
                headers
            }).then((response) => {
                resolve(response.data)
            }).catch((error) => {
                reject(error)
            })
        })
    }

}